// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SLEY","col":"styles_col__3q9X5"};